import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "../lib/api";

export type AgentRuntimeState = "cold" | "starting" | "ready" | "degraded" | "failed";

export type AgentRuntimeStatus = {
  brandId: string;
  state: AgentRuntimeState;
  degraded: boolean;
  detail: string;
  lastReadyAt: string | null;
  updatedAt: string | null;
};

export function useAgentRuntimeStatus(brandId: string | undefined) {
  return useQuery({
    queryKey: ["agent-runtime", brandId],
    queryFn: () => api.get<{ data: AgentRuntimeStatus }>(`/api/brands/${brandId}/agent-runtime`),
    enabled: !!brandId,
    staleTime: 15_000,
  });
}

export function useEnsureAgentRuntime() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (brandId: string) =>
      api.post<{ data: AgentRuntimeStatus }>(`/api/brands/${brandId}/agent-runtime/ensure`),
    onSuccess: (result, brandId) => {
      queryClient.setQueryData(["agent-runtime", brandId], result);
    },
  });
}
